import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-b4f50a96"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "list-box"
};
const _hoisted_2 = {
  class: "list-left"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "list-content"
};
const _hoisted_5 = {
  class: "list-title"
};
const _hoisted_6 = {
  class: "list-other"
};
const _hoisted_7 = {
  class: "list-right"
};
const _hoisted_8 = {
  key: 0,
  class: "refuse-status"
};

const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 申请 ");

const _hoisted_10 = {
  key: 2,
  class: "check-status"
};
const _hoisted_11 = {
  key: 3,
  class: "joined-status"
};
import locale from 'element-plus/lib/locale/lang/zh-cn';
import { Empty } from 'zhs-components';
export default {
  props: {
    show: Boolean
  },
  emits: ['update:show'],

  setup(__props, {
    emit
  }) {
    const $http = inject('$http');

    const handleClose = () => {
      emit('update:show', false);
    };

    const keyWord = ref('');
    const applyList = ref([]); // 获取申请列表

    const getApplyList = async () => {
      let params = {
        keyword: keyWord.value
      };
      const res = await $http.getApplyTeachingGroupList(params);
      applyList.value = res;
    };

    getApplyList(); // 申请

    const handleApply = async id => {
      const res = await $http.applyTeachingGroup({
        id
      });

      if (res) {
        ElMessage.success('申请成功');
        getApplyList();
      }
    };

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_scrollbar = _resolveComponent("el-scrollbar");

      const _component_el_dialog = _resolveComponent("el-dialog");

      const _component_el_config_provider = _resolveComponent("el-config-provider");

      return _openBlock(), _createBlock(_component_el_config_provider, {
        locale: _unref(locale)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_dialog, {
          modelValue: __props.show,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(show) ? show.value = $event : null),
          width: "600px",
          "append-to-body": true,
          title: "申请加入教研室",
          "before-close": handleClose,
          "destroy-on-close": "",
          "close-on-click-modal": false
        }, {
          default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_input, {
            modelValue: keyWord.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => keyWord.value = $event),
            class: "search-input",
            size: "large",
            onKeyup: _withKeys(getApplyList, ["native", "enter"]),
            placeholder: "请输入教研室名称"
          }, {
            suffix: _withCtx(() => [_createElementVNode("i", {
              class: "iconfont icon-sousuo1 search-icon",
              onClick: getApplyList
            })]),
            _: 1
          }, 8, ["modelValue", "onKeyup"]), _createVNode(_component_el_scrollbar, {
            class: "list-scroll"
          }, {
            default: _withCtx(() => [applyList.value.length ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(applyList.value, item => {
              return _openBlock(), _createElementBlock("li", {
                class: "list-item",
                key: item.id
              }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
                src: item.group_cover_url,
                class: "list-img",
                alt: ""
              }, null, 8, _hoisted_3), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(item.group_name), 1), _createElementVNode("div", _hoisted_6, "教研室主任：" + _toDisplayString(item.user_names), 1)])]), _createElementVNode("div", _hoisted_7, [item.status == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_8, "已拒绝")) : _createCommentVNode("", true), item.status == 0 || item.status == 2 ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                class: "apply-btn",
                onClick: $event => handleApply(item.id)
              }, {
                default: _withCtx(() => [_hoisted_9]),
                _: 2
              }, 1032, ["onClick"])) : _createCommentVNode("", true), item.status == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_10, "已申请，审核中")) : _createCommentVNode("", true), item.status == 100 ? (_openBlock(), _createElementBlock("span", _hoisted_11, "已加入")) : _createCommentVNode("", true)])]);
            }), 128))])) : (_openBlock(), _createBlock(_unref(Empty), {
              key: 1,
              text: "暂无数据",
              class: "empty-box"
            }))]),
            _: 1
          })])]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }, 8, ["locale"]);
    };
  }

};